import createVueApp from '@phoenix/createVueApp';
import StrapSizeFinder from '@maison/components/product/StrapSizeFinder.vue';

const app = createVueApp();
app.component('StrapSizeFinder', StrapSizeFinder);
app.mount('#phoenix-strap-size-finder');
